import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgClindamycinGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.576 8.256 28.32 8l-.349.094-15.3 4.136-.348.093-.093.347-4.136 15.301-.094.35.256.255 11.166 11.166.255.256.35-.095 15.3-4.135.347-.094.094-.346 4.135-15.302.095-.349-.256-.255L28.576 8.256ZM9.396 27.948l3.947-14.605 14.605-3.948L38.602 20.05l-3.947 14.605-14.605 3.947L9.395 27.948Zm9.273 1.845c-.575-1.791.247-3.501 2.004-4.064 1.525-.49 2.703.059 3.408 1.165l-1.294.415c-.404-.522-.957-.742-1.762-.484-1.063.341-1.502 1.418-1.131 2.575.374 1.165 1.36 1.794 2.431 1.45.84-.269 1.185-.843 1.204-1.492l1.243-.398c.092 1.407-.561 2.495-2.095 2.987-1.765.567-3.431-.355-4.008-2.154Zm5.56-5.366 1.113-.357 2.007 6.256-1.114.357-2.007-6.256Zm-.085-6.937h-2.42v-1.25h2.42l-1.724-1.724.884-.884 1.724 1.724v-2.42h1.25v2.42l1.725-1.724.884.884-1.725 1.724h2.42v1.25h-2.42l1.725 1.725-.884.884-1.725-1.725v2.42h-1.25v-2.42L23.304 20.1l-.884-.884 1.724-1.725Z",
    fill: "currentColor"
  }));
}

export { SvgClindamycinGlyph as default };
